//framework
import React, { memo } from "react";

//styles
import styles from "components/ConnectingOverlayStyles.module.scss";

//components
import GameCityLoading from "components/Shared/GameCityLoading/GameCityLoading";

//services
import { getCachedBillboardUrl } from "services/loadingConfig";

/**
 * Full-bleed Game City branded overlay for connect / reconnect / "sending you
 * back to the lobby" states. Fades in/out on `show`; keep it always mounted so
 * the fade-out plays. The billboard comes from the cached admin loading-config
 * (refreshed by Preloader on every page load); when null, GameCityLoading
 * shows no billboard at all.
 */
const ConnectingOverlay = memo(function ConnectingOverlay({ show = false, text = "Connecting you to the game", large = false }) {
    return (
        <div className={`${styles.overlay} ${show ? styles.show : ""}`} aria-hidden={!show} aria-busy={show} role="status" >
            <GameCityLoading text={text} large={large} billboardSrc={getCachedBillboardUrl() || undefined} />
        </div>
    );
});

export default ConnectingOverlay;
